import { useAuthStore } from '~/store/authentication';
import { useClientStore } from '~/store/client';

export default defineNuxtPlugin(({ $pinia }) => {
    console.log('[Pinia]: Init.');
    return {
        provide: {
            authentication: useAuthStore($pinia),
            client: useClientStore($pinia),
        }
    }
})